import React, { useCallback, useEffect, useState } from 'react'

import { IOwnProps } from './model'
import { View } from './view'

export const Accordion = (props: IOwnProps) => {
	const [expanded, setExpanded] = useState(false)

	useEffect(() => {
		if (typeof props.expanded !== 'undefined') {
			setExpanded(props.expanded)
		}
	}, [props.expanded])

	const handleChange = useCallback(() => {
		if (typeof props.expanded === 'undefined') {
			setExpanded(!expanded)
		}

		if (props.onChange) {
			props.onChange(!expanded)
		}
	}, [props.onChange, expanded])

	return View({
		...props,
		expanded,
		onToggleExpanded: handleChange,
	})
}
